import { observer } from "mobx-react-lite";
import FinancierSharedView from "../shared/FinancierSharedView";
import FinancierSetting from "../../components/financier/settings/FinancierSetting";

export default observer(function Settings() {
  return <FinancierSharedView mainContent={<FinancierSetting />} />;
});
